import { Component, ElementRef, HostListener, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AppDialogComponent } from '../core/dialogs/app-dialog/app-dialog.component';
import { SafeDialogComponent } from '../core/dialogs/safe-dialog/safe-dialog.component'
import { OrganizerDialogComponent } from '../core/dialogs/organizer-dialog/organizer-dialog.component'
import { ContactDialogComponent } from '../core/dialogs/contact-dialog/contact-dialog.component';
import { TranslateService } from '@ngx-translate/core';


declare var $: any;
@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {
  references = [];
  baseCustomerLogos: string[] = ['/assets/img/customers/albGmbHLogo.png', '/assets/img/customers/cropped-hkt-logo-schwarz-1_intranet (1).png',
    '/assets/img/customers/EIB_Logo freigestellt_300.png', '/assets/img/customers/eins_weißer_Hintergrund.jpeg',
    '/assets/img/customers/GHT-LOGO_neu.png', '/assets/img/customers/GPlogo.png',
    '/assets/img/customers/LAYJET Logo 4c negativ Optimalfreifraum DE.png', '/assets/img/customers/LEONET_Logo_Horizntal_blau.png',
    '/assets/img/customers/Logo - visco GmbH.png', 'assets/img/customers/Logo Aytac.jpg', '/assets/img/customers/MK-Systems Logo 2022 groß.png',
    '/assets/img/customers/Logo Diroba.png', '/assets/img/customers/Logo FST kurz.png', '/assets/img/customers/Max Wild logo_4C-01.png',
    '/assets/img/customers/Logo Störmer neu.png', '/assets/img/customers/Logo_1174x569.JPG', '/assets/img/customers/logo.jpg',
    '/assets/img/customers/Logo_DeNe.png', '/assets/img/customers/Logo_RGB_Farbe-mit-Abstand.png', '/assets/img/customers/Logo-RGB-Neu.jpg',
    '/assets/img/customers/NET-TEC_Logo_quer_Claim_color.png', '/assets/img/customers/NetelLogo.jpg',
    '/assets/img/customers/OXG_Logo.png', '/assets/img/customers/SchoenerTel_Logo_farbig_weisser_Hintergrund.png', '/assets/img/customers/STF_Gruppe_dick_rgb_20190614.png',
    '/assets/img/customers/SXF-PLAN_Logo.png', '/assets/img/customers/WB-Bauer Bauunternehmung quer.jpg'];
  allCustomerLogos: string[] = [];

  @ViewChildren('opacityAnimation') opacityAnimationElements: QueryList<ElementRef>;
  @ViewChildren('upAnimation') upAnimationElements: QueryList<ElementRef>;
  @ViewChildren('fromSideAnimation') fromSideElements: QueryList<ElementRef>;
  @ViewChildren('advantagesOpacityAnimation') advantagesOpacityAnimation: QueryList<ElementRef>;
  @ViewChildren('organizerFromSideAnimation') organizerFromSideAnimation: QueryList<ElementRef>;
  @ViewChildren('upAdviceAnimation') upAdviceAnimation: QueryList<ElementRef>;
  @ViewChildren('opacityDocumentsAnimation') opacityDocumentsAnimation: QueryList<ElementRef>;

  constructor(
    public matDialog: MatDialog,
    private translate: TranslateService
  ) {
    /*---Repeat the images multiple times to loop content smoothly---*/
    for (let i = 0; i < 10; i++) {
      this.allCustomerLogos = this.allCustomerLogos.concat(this.baseCustomerLogos);
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    const animationConfig = [
      { selector: '#presentation', effect: this.opacityAnimationElements },
      { selector: '#system-trio', effect: this.upAnimationElements },
      { selector: '#no-more', effect: this.fromSideElements },
      { selector: '#advantages-container', effect: this.advantagesOpacityAnimation },
      { selector: '#organizer', effect: this.organizerFromSideAnimation },
      { selector: '#advise-items-container', effect: this.upAdviceAnimation },
      { selector: '#documents-text-container', effect: this.opacityDocumentsAnimation }
    ];

    animationConfig.forEach(item => {
      this.setAnimations(item.selector, item.effect);
    });
  }

  setAnimations(containerElement: any, elementsToAnimate: any) {
    const elementsContainer = document.querySelector(containerElement);
    const rect = elementsContainer.getBoundingClientRect();
    const _windowHeight = window.innerHeight - 170;
    const isVisible = rect.top < _windowHeight && rect.bottom >= 0;

    elementsToAnimate.forEach(el => {
      if (isVisible) {
        el.nativeElement.classList.add('visible');
      }
    })
  }

  animateElement(el: any) {
    const rect = el.nativeElement.getBoundingClientRect();
    const _windowHeight = window.innerHeight - 220;
    const isVisible = rect.top < _windowHeight && rect.bottom >= 0;

    if (isVisible) {
      el.nativeElement.classList.add('visible');
    }
  }

  ngOnInit() {
    this.initReferences();

    this.translate.onLangChange.subscribe(lang => {
      this.initReferences();
    })
  }

  ngAfterViewInit() {
    this.setAnimations('#presentation', this.opacityAnimationElements); // check visibility of Presentation section to init animation on big screens
  }

  initReferences() {
    this.references = [];
    this.translate.get('about.header').subscribe((text: string) => {
      for (let i = 1; i < 10; i++) {
        this.references.push({
          id: i,
          text: this.translate.instant('reference.' + i + 'referenceText'),
          signature: this.translate.instant('reference.' + i + 'referenceSignature')
        })
      }
      setTimeout(() => {
        this.restartRefferenceSlider();
      }, 100);
    });
  }

  restartRefferenceSlider() {
    $('#referenceCarousel').carousel({
      interval: 3000
    })

    $('.carousel-multiple-item .carousel-item-multiple-item').each(function () {
      var minPerSlide = 3;
      var next = $(this).next();
      if (!next.length) {
        next = $(this).siblings(':first');
      }
      next.children(':first-child').clone().appendTo($(this));

      for (var i = 0; i < minPerSlide; i++) {
        next = next.next();
        if (!next.length) {
          next = $(this).siblings(':first');
        }

        next.children(':first-child').clone().appendTo($(this));
      }
    });
  }

  getItem(item) {
    if (item == 'en' || item == 'fr' || item == 'es') {
      return localStorage.getItem(item)
    }
    return 'en';
  }

  openModalApp() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.id = "app-dialog-component";
    const modalDialog = this.matDialog.open(AppDialogComponent, dialogConfig);
  }
  openModalSafe() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.id = "safe-dialog-component";
    const modalDialog = this.matDialog.open(SafeDialogComponent, dialogConfig);
  }
  openModalOrganizer() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.id = "organizer-dialog-component";
    const modalDialog = this.matDialog.open(OrganizerDialogComponent, dialogConfig);
  }
  openModalContact() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = false;
    dialogConfig.id = "app-dialog-component";
    dialogConfig.data = { preventAddingClass: false };
    const modalDialog = this.matDialog.open(ContactDialogComponent, dialogConfig);
  }
}
